import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import { Typography } from "@mui/material";
import axiosInstance from "../../helpers/axios";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';
import Button from "@mui/material/Button";
import close from "./close.png";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "./datepicker";
import AddStd from "./addStd";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import { alpha } from "@mui/material/styles";

import CustomStepper from "./customStepper";

import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { useCurrentUser } from '../../hooks/useCurrentUser';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "45%",
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: 100,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginTop: "10px",
  marginRight: 0,
  marginLeft: "0px",
  width: "100%",
  height:'50px',
  [theme.breakpoints.up("sm")]: {
    marginRight: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  color: "grey",
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  right: "0",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: "5",
}));



const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    backgroundColor: "#F5F7FA",
    borderRadius: "10px",
    padding: theme.spacing(1.4, 0, 1.4, 2),
    // vertical padding + font size from searchIcon
    paddingRight: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "200px",
      "&:focus": {
        width: "200px",
      },
    },
  },
}));


const Qec = ({ eligibility }) => {
  const decode = useCurrentUser();
  const user = null;
  const [tableData, setTableData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(null);
  const [studentName,setStudentName] = useState('')
  const [searchClicked,setSearchClicked] = useState(false)
  const [fromDate,setFromDate] = useState(null)
  const [toDate,setToDate] = useState(null)
  const [modalOpen, setModalOpen] = React.useState(false);
  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  useEffect(() => {
    let queryParams = {}
    if(decode){
      queryParams.instituteId = decode.instituteId || "1a62ed6b-a5f5-4ab3-acfa-6e353b070149";
    }
      queryParams.pageNo = currentPage;
    
    if(rowsPerPage){
      queryParams.perPage = rowsPerPage;
    }
    if(studentName){
      queryParams.studentName = studentName;
    }
    if(fromDate && toDate){
      queryParams.fromDate = fromDate;
      queryParams.toDate = toDate
    }
    axiosInstance
      .get("rules/get-qec", {
        params: queryParams
      })
      .then((res) => {
        const fetchedTableData = res?.data?.data;
        setTableData(res?.data?.data?.data);
        setRowsPerPage(res?.data?.data?.pagination?.perPage)
        setCurrentPage(res?.data?.data?.pagination?.currentPage)
        setTotalRows(res?.data?.data?.pagination?.totalRows)
      })
      .catch((err) => {
      });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const handlePageChange = (e, value) => {
    setIsLoading(true)
    paginate(value);
  };

  const handleInputChange = (event) => {
    setStudentName(event.target.value);
  };
  const paginate = (pageNumber) => {
    let queryParams = {}
    if(decode){
      queryParams.instituteId = decode.instituteId || "1a62ed6b-a5f5-4ab3-acfa-6e353b070149";
    }
      queryParams.pageNo = pageNumber;
    
    if(rowsPerPage){
      queryParams.perPage = rowsPerPage;
    }
    if(studentName){
      queryParams.studentName = studentName;
    }
    if(fromDate && toDate){
      queryParams.fromDate = fromDate;
      queryParams.toDate = toDate
    }
    axiosInstance
      .get("rules/get-qec", {
        params: queryParams
      })
      .then((res) => {
        const fetchedTableData = res?.data?.data;
        setTableData(res?.data?.data?.data);
        setRowsPerPage(res?.data?.data?.pagination?.perPage)
        setCurrentPage(res?.data?.data?.pagination?.currentPage)
        setTotalRows(res?.data?.data?.pagination?.totalRows)
        setIsLoading(false);
       
      })
      .catch((err) => {
      });
  };

  const handleSearchClick = ()=>{
    setSearchClicked(!searchClicked)
    let queryParams = {}
    if(decode){
      queryParams.instituteId = decode.instituteId || "1a62ed6b-a5f5-4ab3-acfa-6e353b070149";
    }
      queryParams.pageNo = currentPage;
    
    if(rowsPerPage){
      queryParams.perPage = rowsPerPage;
    }
    if(studentName){
      queryParams.studentName = studentName;
    }
    if(fromDate && toDate){
      queryParams.fromDate = fromDate;
      queryParams.toDate = toDate
    }

    axiosInstance
      .get("rules/get-qec", {
        params: queryParams
      })
      .then((res) => {
        const fetchedTableData = res?.data?.data;
        setTableData(res?.data?.data?.data);
        setRowsPerPage(res?.data?.data?.pagination?.perPage)
        setCurrentPage(res?.data?.data?.pagination?.currentPage)
        setTotalRows(res?.data?.data?.pagination?.totalRows)
      })
      .catch((err) => {
      });
  }

  const handleClearClick = ()=>{
    window.location.reload()
 
    setStudentName('')
    setSearchClicked(false)
  }

  const [rules,setRules] = useState([])

  const handleRules = (item) => {
    const getRules = `/go-rules/get-result-qec?userId=${item?.userId}&applicationId=${item?.applicationId}`;
  
    axiosInstance
      .get(getRules)
      .then((res) => {
  
        const data = res?.data?.data;
        const manualApprove = data.filter((currentItem) => currentItem.overall === "orange");
        const manualApproveItems = Object.values(
          manualApprove.reduce((accumulator, currentItem) => {
            if (!accumulator[currentItem.source]) {
              accumulator[currentItem.source] = currentItem; 
            }
            return accumulator;
          }, {})
        );
        setRules(manualApproveItems)
      })
      .catch((err) => {
      });
  };
  

  return (
    <>
     <div>
      <Modal
        open={modalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{display:'flex',justifyContent:'space-between',marginTop:'-10px'}}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Eligibility 
          </Typography>
          <img src={close} style={{cursor:'pointer'}} onClick={handleClose} alt=""/>
          </div>
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><strong>Source</strong></TableCell>
                  <TableCell><strong>Result</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rules.map((item, index) => {
                  const orangeFlags = Object.keys(item.flag).filter((key) => item.flag[key] === "orange");

                  return (
                    <TableRow key={index}>
                      <TableCell>{item.source}</TableCell>
                      <TableCell>{orangeFlags.join(", ") || "No Orange Flags"}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>
    </div>
    <Card>

              <Card
                sx={{
                  boxShadow: "none",
                  borderRadius: "10px",
                  p: "5px",
                  m:"20px"
                }}
              >
                {/* qec from and to due box */}

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="for-dark-bottom-border"
                >
                  <AddStd />
                </Box>
                    <Search className="search-form">
                      <SearchIconWrapper
                        sx={{ display: { xs: "none", sm: "inline-flex" } }}
                      >
                        <SearchIcon />
                      </SearchIconWrapper>

                      <StyledInputBase
                        placeholder="Student Name.."
                        inputProps={{ "aria-label": "search" }}
                        onChange={handleInputChange}
                      />
                    </Search>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {/* from date */}
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          <DatePicker
                            label="From Date"
                            sx={{
                              paddingRight: "10px",
                              boxShadow: "none",
                              ".MuiOutlinedInput-notchedOutline": {
                                border: 1,
                                borderColor: "#F7FAFF",
                              },
                              width: "200px",
                            }} value={fromDate} onChange={(date) => setFromDate(date)}
                          />
                        </DemoContainer>
                      </LocalizationProvider>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          <DatePicker
                            label="To Date"
                            sx={{
                              boxShadow: "none",
                              ".MuiOutlinedInput-notchedOutline": {
                                border: 1,
                                borderColor: "#F7FAFF",
                              },
                              width: "200px",
                            }} value={toDate} onChange={(date) => setToDate(date)}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Box>
                    {searchClicked === true ? (
                      <Button
                      type="button"
                      variant="contained"
                      sx={{
                        mt: 1,
                        textTransform: "capitalize",
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "14px",
                        padding: "10px",
                        color: "#fff !important",width:'150px',bgcolor:'#d32028'
                      }} onClick={handleClearClick}
                    >
                      
                      CLEAR FILTERS
                    </Button>
                    ):(
          <Button
                      type="button"
                      variant="contained"
                      sx={{
                        textTransform: "capitalize",
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "13px",
                        padding: "12px 20px",
                        color: "#fff !important",
                        height: "35px",
                        marginLeft: "50px",
                        width: "130px",bgcolor:'#d32028'
                      }} onClick={handleSearchClick}
                    >
                      Search Result
                    </Button>
                    )}
                    
                  </Box>
                </Box>
              </Card>

              <Card
                sx={{
                  boxShadow: "none",
                  borderRadius: "10px",
                  p: "15px",
                  mb: "15px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #EEF0F7",
                    paddingBottom: "10px",
                    marginBottom: "15px",
                  }}
                  className="for-dark-bottom-border"
                >
                  <Typography
                    as="h3"
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  >
                    Total Students Details
                  </Typography>

                  {/*new pagination beigns */}
                <Stack>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        as="h3"
                        sx={{
                          fontSize: 16,
                          marginRight: "2em",
                          fontWeight: 500,
                        }}
                      >
                        Showing {currentPage * rowsPerPage + 1 - rowsPerPage} to {currentPage * rowsPerPage - rowsPerPage+tableData?.length} of {totalRows}
                      </Typography>
                      <Pagination
                        count={Math.ceil(totalRows / rowsPerPage)}
                        page={currentPage}
                        onChange={handlePageChange}
                        variant="outlined"
                        color="primary"
                      />
                    </div>
                  </Stack>

                  {/*new pagination ends */}

                  {/* select page pagination begins */}
                  {/*
                  <Box>
                    <FormControl sx={{ minWidth: 120 }} size="small">
                      <InputLabel id="demo-select-small" sx={{ fontSize: "14px" }}>
                        Select Page
                      </InputLabel>
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        label="Select"
                        value={selectPage}
                        onChange={(e) => handlePageChange(e)}
                        sx={{ fontSize: "14px" }}
                      >
                        {pageArray.map((item, index) => (
                          <MenuItem value={item} sx={{ fontSize: "14px" }}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  */}

                  {/* select page pagination end */}
                </Box>

                {/* table begins  */}

                <TableContainer
                  component={Paper}
                  sx={{
                    boxShadow: "none",
                  
                  }}
                >
                  <Table
                    sx={{ minWidth: 700 }}
                    aria-label="simple table"
                    className="dark-table"
                  >
                    <TableHead sx={{ background: "#F9FAFB" }}>
                      <TableRow>
                        
                        <TableCell
                          sx={{
                            borderBottom: "1px solid #F7FAFF",
                            fontSize: "13.5px",
                            padding: "16px 80px 16px 10px",
                          }}
                          align="left"
                        >
                        Application Id
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: "1px solid #F7FAFF",
                            fontSize: "13.5px",
                            padding: "16px 80px 16px 0px",
                          }}
                          align="left"
                        >
                          Name
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: "1px solid #F7FAFF",
                            fontSize: "13.5px",
                            padding: "16px 80px 16px 0px",
                          }}
                          align="left"
                        >
                          Created On
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: "1px solid #F7FAFF",
                            fontSize: "13.5px",
                            padding: "16px 80px 16px 0px",
                          }}
                          align="left"
                        >
                          PAN No.
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: "1px solid #F7FAFF",
                            fontSize: "13.5px",
                            padding: "16px 40px 16px 40px",
                          }}
                          align="left"
                        >
                          Mobile
                        </TableCell>

                        <TableCell
                          sx={{
                            borderBottom: "1px solid #F7FAFF",
                            fontSize: "13.5px",
                            padding: "16px 0px 16px 80px",
                          }}
                          align="left"
                        >
                          Status
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {isLoading ? (
                       <TableRow>
                       <TableCell colSpan={6} align="center">
                       <Box style={{ display: 'flex',justifyContent:'center',alignItems:'center' }}>
                        <CircularProgress style={{display:'flex',justifyContent:'center',alignItems:'center'}} />
                      </Box>
                       </TableCell>
                     </TableRow>
                     
                    ):(
                      <TableBody>
                      {/* TableRow 1 */}

                      {tableData?.map((item) => {
                        const steps = [
                          { label: "Consent" },
                          { label: "Approved/Reject",index: 5},
                          { label: "Complete Appl.", index: 0 },
                          { label: "Cibil & Income", index: 2 },
                          {
                            label: 
                              item?.applicantTracker?.bsaLinkStatus
                                ? "BsLinkSent"
                                : item?.applicantTracker?.postSanctionStatus
                                ? "postSanctionLink Sent"
                                : "Link Sent",
                            index: 3
                          },
                          { label: "Digilocker", index: 4  },
                          { label: "Selfie", index: 9},
                          { label: "Agreement", index: 6 },
                          { label: "E Mandate", index: 7 },
                          { label: "Disbursed", index: 8 },
                        ];
                        // const steps = [
                        //   { label: "Consent",index:0 },
                        //   { label: "Approved/Reject",index: 1},
                        //   { label: "Complete application", index: 2 },
                        //   { label: "Cibil & Income", index: 3 },
                        //   { label: "Selfie", index: 4 },
                        //   { label: "Kyc", index: 5 },
                        //   { label: "Agreement", index: 6 },
                        //   { label: "E Mandate", index: 7 },
                        //   { label: "Disbursed", index: 8 },
                        // ];





                        return (
                          <>
                            <TableRow>
                            

                              <TableCell
                                sx={{
                                  fontWeight: "bold",
                                  borderBottom: "0px solid #F7FAFF",
                                  fontSize: "13.5px",
                                  padding: "16px 80px 16px 10px",
                                  display:'flex',cursor:'pointer'
                                }} onClick={item.approvedBy === 2 ? () => {handleRules(item);handleOpen()}:null}
                                align="left"
                              >
                                <span
                                  style={{
                                    cursor: "pointer",textDecoration:'underline'
                                  }}
                                >{item?.applicationId}</span>
                                
                                <div style={{marginLeft:'10px',marginBottom:'-10px',marginTop:'-1px'}}>{item.approvedBy?(
                            item.approvedBy === 1? (
                              <span title='Automatic' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'25px',width:'25px',display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',fontWeight:'bold',padding:'5px',cursor:'pointer',color:'black',lineHeight:'1rem'}} >A</span>
                            ) : item.approvedBy === 2 ? (
                              <span title='Manual' style={{fontSize:'12px',backgroundColor:'#F8A31F',borderStyle:'solid',borderRadius:'50%',border:'none',height:'25px',width:'25px',display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',fontWeight:'bold',padding:'5px',cursor:'pointer',color:'black',lineHeight:'1rem'}} >M</span>
                            ) :item.approvedBy
                          ):"-"
                        } </div>
                              </TableCell>

                              <TableCell
                                align="left"
                                sx={{
                                  fontWeight: 500,
                                  borderBottom: "0px solid #F7FAFF",
                                  fontSize: "13.5px",
                                  padding: "16px 80px 16px 0px",
                                }}
                              >
                                {" "}
                                {item?.studentName}
                              </TableCell>

                              <TableCell
                                align="left"
                                sx={{
                                  borderBottom: "0px solid #F7FAFF",
                                  fontSize: "13.5px",
                                  padding: "16px 80px 16px 0px",
                                }}
                              >
                                {(item?.createdAt).substring(0,10)}
                              </TableCell>

                              <TableCell
                                align="left"
                                sx={{
                                  borderBottom: "0px solid #F7FAFF",
                                  fontSize: "13.5px",
                                  padding: "16px 80px 16px 0px",
                                }}
                              >
                                {item.panId}
                              </TableCell>

                              <TableCell
                                align="left"
                                sx={{
                                  borderBottom: "0px solid #F7FAFF",
                                  fontSize: "13.5px",
                                  padding: "16px 40px 16px 40px",
                                }}
                              >
                                {item?.phone}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{
                                  fontWeight: "bold",
                                  borderBottom: "0px solid #F7FAFF",
                                  fontSize: "13.5px",
                                  padding: "16px 0px 16px 80px",
                                }}
                              >
                                {item?.eligibility !== 2
                                  ? item?.status
                                  : "Not Eligible"}
                              </TableCell>
                            </TableRow>
                            <TableRow className="table-body">
                              <td colSpan="9">
                                <Box
                                  sx={{
                                    width: "97%",
                                    marginLeft: "3%",
                                    backgroundColor: "#F9FAFB",
                                    borderRadius: "10px",
                                    paddingTop: "0.7em",
                                    boxShadow: "0px 0px 2px 0px gray",marginTop:'-10px'
                                  }}
                                >
                                  <>
                                    <CustomStepper
                                      eligibility={item?.eligibility}
                                      applicationId={item?.applicationId}
                                      user={item}
                                      steps={steps}
                                      activeStep={
                                        item.status === "In Submission"
                                          ? 0
                                          : item.status === "In Review"
                                          ? 1
                                          : item.status === "In Process"
                                          ? 2
                                          : item.status === "In Sanction"
                                          ? 3
                                          : item.status === "Disbursed"
                                          ? 4
                                          : -1
                                      }

                                      apptrackeR={
                                        item.applicantTracker
                                      }
                                    />
                                  </>
                                </Box>
                              </td>
                            </TableRow>
                          </>
                        );
                      })}
                    </TableBody>
                    )}
                  
                  </Table>
                </TableContainer>
              </Card>
              </Card>
    </>

  );
};

export default Qec;
